import React, {createContext, useContext, useState} from 'react';
import {Marketplace} from '@/types/enums';

interface MarketplaceContextType {
    selectedMarketplace: Marketplace;
    setSelectedMarketplace: (marketplace: Marketplace) => void;
}

const MarketplaceContext = createContext<MarketplaceContextType | undefined>(undefined);

export function MarketplaceProvider({children}: { children: React.ReactNode }) {
    const [selectedMarketplace, setSelectedMarketplace] = useState<Marketplace>(Marketplace.Trendyol);

    return (
        <MarketplaceContext.Provider value={{selectedMarketplace, setSelectedMarketplace}}>
            {children}
        </MarketplaceContext.Provider>
    );
}

export function useMarketplace() {
    const context = useContext(MarketplaceContext);
    if (context === undefined) {
        throw new Error('useMarketplace must be used within MarketplaceProvider');
    }
    return context;
}

